import {useState} from "react";
import {DisclosureArrow} from "./DisclosureArrow";

export const AccordionSection = ({
                                     title,
                                     defaultOpen = false,
                                     open: controlledOpen,
                                     onOpenChange = null,
                                     collapsible = true,
                                     className = "",
                                     children
                                 }) => {
    const [open, setOpen] = useState(defaultOpen);
    const isOpen = collapsible ? controlledOpen ?? open : true;

    const handleToggle = (e) => {
        const nextOpen = e.currentTarget.open;
        if (controlledOpen === undefined) {
            setOpen(nextOpen);
        }
        onOpenChange?.(nextOpen);
    }

    if (!collapsible) {
        return <section className={`accordion-section accordion-section-non-collapsible ${className}`}>
            <div className="accordion-section-header">
                <span>{title}</span>
            </div>
            <div className="accordion-section-content">
                {children}
            </div>
        </section>;
    }

    return <details className={`accordion-section ${className}`} open={isOpen}
                    onToggle={handleToggle}>
        <summary className="accordion-section-header">
            <span>{title}</span>
            <DisclosureArrow/>
        </summary>
        <div className="accordion-section-content">
            {children}
        </div>
    </details>;
}
